import React from 'react';
import { useParams , useLocation , useNavigate } from 'react-router-dom';

const User = () => {
  const {fname , lname} = useParams();
  const location = useLocation();
  const history = useNavigate();
  
  const handleClick = () =>{
    history(-1)
  }
  
  return (<>
<h1>User {fname} {lname} Page</h1>
<p>My current url is {location.pathname}</p>

{location.pathname === `/user/Moobeen/Quader` ? 
(
  <button className='btn btn-primary' onClick={handleClick}>Click</button>
) : null
}
  </>);
};

export default User;
